/**
 * Stellt einen allgemein Übersetzer für Strings bereit.
 *
 * Das Modul exportiert folgende Funktionen:
 * - Translator: Klasse für Übersetzer
 * - singleton: Standardobjekt, reicht für die meisten Fälle aus
 * 
 */


var _ = require('underscore');
var format = require('./format.js');

/**
 * Stellt einen allgemein Übersetzer für Strings bereit. Funktionen:
 * 
 * - Einfache Work-Übersetzung -> get(word)
 * - Basierend auf Anzahl -> plural(word, count)
 */
var Translator = function() {
	this.dictionary = {};
	this.language = 'de';

	this.currencies = {
		'EUR': { prefix: '', suffix: ' €', dec_point: ',', thousands_sep: '.' },
		'GPB': { prefix: '', suffix: ' £', dec_point: '.', thousands_sep: ',' },
		'CHF': { prefix: '', suffix: ' CHF', dec_point: ',', thousands_sep: "'" },
		'USD': { prefix: '$', suffix: '', dec_point: '.', thousands_sep: '.' },
	};

	_.bindAll(this, "learn", "setLanguage", "get", "plural", "currency", "currencyHTML");
};

/**
 * Dem Übersetzer weitere Strings beibringen.
 *
 * @param language {String} Sprachcode (de, en, ...)
 * @param definitions {Object} Key-Value Mapping von Wörtern. Plural-Versionen mit *_plural.
 */
Translator.prototype.learn = function(language, definitions) {
	if ( typeof this.dictionary[language] === "undefined" ) {
		this.dictionary[language] = {};
	}
	_.extend(this.dictionary[language], definitions);
};

/**
 * Standardsprache für die get-Funktionen setzen
 *
 * @param language {String} Sprachcode (de, en, ...)
 */
Translator.prototype.setLanguage = function(language) {
	if ( typeof this.dictionary[language] === "undefined" ) {
		/* Language not defined yet :-( */
		return false;
	}
	this.language = language;
	return true;
};

/**
 * Ein einzelnes Wort übersetzen. Gibt das Wort zurück falls keine Definition gefunden.
 *
 * @param word {String} Word aus dem Wörterbuch
 */
Translator.prototype.get = function(word, replacements) {
	var dict = this.dictionary[this.language];
	var result;
	if ( typeof dict !== "undefined" && typeof dict[word] !== "undefined" ) {
		result = dict[word];
	} else {
		result = word;
	}

	if ( typeof result === "string" && !_.isEmpty(replacements) ) {
		_.each(replacements, function(value, key) {
			result = result.replace('{' + key + '}', value);
		});
	}

	return result;
};

/**
 * Ein einzelnes Wort übersetzen, basierend auf der Plural-Form. Gibt das Wort + die Anzahl zurück.
 *
 * @param word {String} Word aus dem Wörterbuch
 * @param count {Number} Anzahl
 */
Translator.prototype.plural = function(word, count) {
	if ( typeof count === "undefined" ) {
		throw new Error("Translator.plural: count is undefined (wrong method called?)");
	}

	if ( count === 0 || count > 1 ) {
		return count + " " + this.get(word + "_plural");
	}
	return count + " " + this.get(word);
};

/**
 * Währung formatieren
 *
 * @param amount {Number} Wert
 * @param currency {String} Währung (EUR, GBP, CHF, USD, etc.)
 */
Translator.prototype.currency = function(amount, currency, precision) {
	var c = this.currencies[currency];
	precision = typeof precision === "undefined" ? 2 : 0;
	if ( !c ) {
		throw new Error("Translator: Unkown currency: " + currency);
	}
	return c.prefix + format.number(amount, precision, c.dec_point, c.thousands_sep) + c.suffix;
};

/**
 * Währung formatieren. Packt den Präfix oder Suffix in ein span-Element mit der Klasse currency.
 *
 * @param amount {Number} Wert
 * @param currency {String} Währung (EUR, GBP, CHF, USD, etc.)
 */
Translator.prototype.currencyHTML = function(amount, currency, precision) {
	var c = this.currencies[currency];
	precision = typeof precision === "undefined" ? 2 : 0;
	if ( !c ) {
		throw new Error("Translator: Unkown currency: " + currency);
	}
	var prefix = '', suffix = ''; 
	if ( c.prefix != "" ) prefix = '<span class="currency">' + c.prefix + '</span> ';
	if ( c.suffix != "" ) suffix = ' <span class="currency">' + c.suffix + '</span>';

	return (
		  prefix
		+ '<span class="digits">'
		+ format.number(amount, precision, c.dec_point, c.thousands_sep)
		+ '</span>'
		+ suffix
	);
};

/**
 * Registriert alle Übersetzer-Funktionen mit einem TemplateCache
 */
Translator.prototype.registerHelpers = function(templatecache) {
	templatecache.helper("__", this.get);
	templatecache.helper("___", this.plural);
	templatecache.helper("currency", this.currency);
	templatecache.helper("currencyHTML", this.currencyHTML);
};

module.exports = {
	Translator: Translator,
	singleton: new Translator(),
};



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/translate/index.js
 **/